import { render } from "./DuplicateManagerModal.vue?vue&type=template&id=e6756df6&scoped=true"
import script from "./DuplicateManagerModal.vue?vue&type=script&lang=js"
export * from "./DuplicateManagerModal.vue?vue&type=script&lang=js"

import "./DuplicateManagerModal.vue?vue&type=style&index=0&id=e6756df6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6756df6"]])

export default __exports__